import type { HelperPortInfo } from '@/features/serial/helperClient';

const REQUEST_TIMEOUT_MS = 2500;

/** Lists COM ports from the Vite dev server (local machine only). */
export async function fetchLocalDevPorts(): Promise<HelperPortInfo[]> {
  try {
    const response = await fetch('/api/dev/ports', {
      signal: AbortSignal.timeout(REQUEST_TIMEOUT_MS),
    });

    if (!response.ok) {
      return [];
    }

    const data = (await response.json()) as { ports?: HelperPortInfo[] };
    return data.ports ?? [];
  } catch {
    return [];
  }
}
